import { Link } from '@tanstack/react-router';
import { Card, CardContent, cn } from '@pantry/ui';

/**
 * Quick action card component
 */
export function QuickActionCard({
  title,
  description,
  icon: Icon,
  href,
  variant = 'default',
  delay = 0,
  dataTour,
}: {
  title: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  href: string;
  variant?: 'default' | 'primary';
  delay?: number;
  dataTour?: string;
}) {
  return (
    <Link
      to={href}
      className="block animate-in"
      style={{ animationDelay: `${delay}ms` }}
      data-tour={dataTour}
    >
      <Card
        className={cn(
          'h-full transition-all duration-200 hover:shadow-md group',
          variant === 'primary'
            ? 'bg-primary text-primary-foreground hover:bg-primary/90'
            : 'hover:border-primary/30'
        )}
      >
        <CardContent className="p-5">
          <div
            className={cn(
              'flex h-10 w-10 items-center justify-center rounded-lg mb-3 transition-transform group-hover:scale-110',
              variant === 'primary' ? 'bg-primary-foreground/20' : 'bg-muted'
            )}
          >
            <Icon
              className={cn(
                'h-5 w-5',
                variant === 'primary' ? 'text-primary-foreground' : 'text-muted-foreground'
              )}
            />
          </div>
          <h3
            className={cn(
              'font-medium',
              variant === 'primary' ? 'text-primary-foreground' : 'text-foreground'
            )}
          >
            {title}
          </h3>
          <p
            className={cn(
              'text-sm mt-1',
              variant === 'primary' ? 'text-primary-foreground/70' : 'text-muted-foreground'
            )}
          >
            {description}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
}
